import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('sac_currency') || 'EUR');
  const [rates, setRates] = useState({ EUR: 1.0, PLN: 4.25, CHF: 0.93, CAD: 1.47 });
  const [markup, setMarkup] = useState(1.5);

  useEffect(() => {
    axios.get(`${API}/fx/rates`).then(r => {
      setRates(r.data.rates || {});
      setMarkup(r.data.markup_percent || 1.5);
    }).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem('sac_currency', c);
  };

  const convert = (amount, fromCurrency = 'EUR') => {
    if (fromCurrency === currency) return amount;
    const fromRate = rates[fromCurrency] || 1;
    const toRate = rates[currency] || 1;
    const converted = (amount / fromRate) * toRate;
    const withMarkup = converted * (1 + markup / 100);
    return Math.round(withMarkup * 100) / 100;
  };

  const format = (amount, fromCurrency = 'EUR') => {
    const converted = convert(amount, fromCurrency);
    const symbols = { EUR: '€', PLN: 'zł', CHF: 'CHF ', CAD: 'CA$' };
    return `${symbols[currency] || currency} ${converted.toFixed(2)}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rates, format, convert }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
